module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAWCAYAAAC7ZX7KAAABa0lEQVR4nM2XPS8EQRyHn+EShUZHJJQKVKIg8RInR3Jeal9C7VMolQqJgi8giEIkSIhCo6NAJCrxFs1dforbzY2NnVnF3HiSf7Kzs5s888vkv7NGEgVYBRaB+SIPB0WSr0bUZFdSqcA7warNs54Z4Cq7xkDZFcOxmglJX1a6mzGTTStvoqyfbMQWdQlXJdX+W7J5wmOZZLdjC7qElyR9WLJbseVcwnbrkqT12GJ5ZSTNAvtAKWkcR8Ay0Al0xOpev2CAupF0D/RZE8805LtiWDkwwJuRFPdD8EdKwA6wYt17BM6BnihG+Rjg0yQBHwKVZOIJGAReI4k5Sc8Sc8Bpct0LXAPDUYw8mMwWPgamrfEQcNNKIR/Z01qFRotLOQEmW6fjJ5twyiUwao37gYeWGHnIOw+XgQNrfAGMh9fxk5dwyhlN0TowANyFlnLh++OYAvaS63bgFugOauTBJ1wDFmjs6XdgDXgJLeXiG/ag7qa5gZSoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-left.png
// module id = Ae2N
// module chunks = 1